import { CircleStackIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const EmptyPlaceholder = ({
  children = null,
  classNames = "",
  description = "No items found. Try clearing any filters.",
  icon: Icon = CircleStackIcon,
  title = "No Data",
}) => (
  <div className={`${classNames} relative flex flex-col items-center justify-center grow p-12 text-center border-2 border-dashed rounded-lg border-gray-300 dark:border-content2-foreground`}>
    {Icon && <Icon className="w-24 h-24 mb-2 text-indigo-800 dark:text-content2-foreground" />}
    <h1 className="text-xl font-semibold text-content2-foreground">{title}</h1>
    <p className="block mb-4 text-content2-foreground">{description}</p>
    {children}
  </div>
)

EmptyPlaceholder.propTypes = {
  caption: PropTypes.string,
  classNames: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.elementType,
  title: PropTypes.string,
}

export { EmptyPlaceholder }